import { Theme, createTheme, responsiveFontSizes } from '@mui/material/styles'

const createCustomTheme = (primaryColor: string, secondaryColor: string, fontName: string, fontColor: string) => {
  let theme: Theme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: secondaryColor,
      },
      background: {
        paper: '#F8F9FA'
      },
      text: {
        primary: fontColor,
        secondary: fontColor
      }
    },
    typography: {
      allVariants: {
        fontFamily: fontName || "'Calibri', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        color: fontColor
      }
    },
  });

  // Make the theme responsive
  theme = responsiveFontSizes(theme);

  return theme;
}

export const montanaTheme: Theme = createTheme({
  palette: {
    primary: {
      main: '#0033A0'
    },
    secondary: {
      // main: '#953192'
      main: '#0033A0'
    },
    background: {
      paper: '#F8F9FA'
    },
    text: {
      primary: '#1E1E1E',
      secondary: '#1E1E1E'
    }
  },
  typography: {
    allVariants: {
      fontFamily: "'Arial', sans-serif",
      color: '#1E1E1E'
    },
  },
});

export default createCustomTheme;

/*const theme: Theme = createTheme({
  palette: {
    primary: {
      main: '#4297CB'
    },
    secondary: {
      // main: '#953192'
      main: '#981d97'
    },
    background: {
      paper: '#F8F9FA'
    },
    text: {
      primary: '#373737',
      secondary: '#373737'
    }
  },
  typography: {
    allVariants: {
      fontFamily: "'Calibri', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      color: '#373737'
    },
  },
});

export default theme;*/